import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "@styles/fonts.css";
import "react-toastify/dist/ReactToastify.css";
import "react-advanced-cropper/dist/style.css";
import "@styles/app.scss";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
